// Generic chips+input tag editor. Generalized from the servedModels editor in
// register.jsx (EndpointModelTab) — same interaction contract (Enter/comma commits,
// paste-multi splits on comma/newline, Backspace on an empty draft removes the last
// chip, click anywhere in the box focuses the input), controlled via plain
// value/onChange instead of react-hook-form's watch/setValue.

import React, { useState } from 'react';

export function TagInput({
  value = [],
  onChange,
  placeholder = '输入后回车，或用逗号/换行分隔多个…',
  maxItems,
  maxItemLength,
}) {
  const [draft, setDraft] = useState('');

  const commit = (next) => onChange?.(next);

  const add = () => {
    const names = draft
      .split(/[,\n]/)
      .map((s) => s.trim())
      .filter(Boolean)
      .map((s) => (maxItemLength ? s.slice(0, maxItemLength) : s));
    if (!names.length) return;
    let next = [...new Set([...value, ...names])];
    if (maxItems) next = next.slice(0, maxItems);
    commit(next);
    setDraft('');
  };

  const remove = (item) => commit(value.filter((v) => v !== item));

  const atLimit = maxItems != null && value.length >= maxItems;

  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        gap: 7,
        alignItems: 'center',
        padding: '7px 9px',
        minHeight: 42,
        border: '1px solid var(--line)',
        borderRadius: 9,
        background: 'var(--bg-2)',
        cursor: 'text',
      }}
      onClick={(e) => {
        const inp = e.currentTarget.querySelector('input');
        if (inp) inp.focus();
      }}
    >
      {value.map((item) => (
        <span
          key={item}
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: 6,
            padding: '4px 10px',
            borderRadius: 7,
            background: 'var(--bg-1)',
            border: '1px solid var(--line)',
            fontSize: 12.5,
            fontFamily: 'ui-monospace, monospace',
            color: 'var(--fg-1)',
          }}
        >
          {item}
          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              remove(item);
            }}
            title="移除"
            style={{
              background: 'none',
              border: 'none',
              color: 'var(--fg-3)',
              cursor: 'pointer',
              fontSize: 13,
              lineHeight: 1,
              padding: 0,
            }}
          >
            ×
          </button>
        </span>
      ))}
      {!atLimit && (
        <input
          className="mono"
          style={{
            flex: 1,
            minWidth: 170,
            border: 'none',
            background: 'transparent',
            color: 'var(--fg-0)',
            fontSize: 12.5,
            outline: 'none',
            padding: '2px 0',
          }}
          placeholder={value.length ? '继续添加…' : placeholder}
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter' || e.key === ',') {
              e.preventDefault();
              add();
            } else if (e.key === 'Backspace' && !draft && value.length) {
              remove(value[value.length - 1]);
            }
          }}
          onBlur={add}
        />
      )}
    </div>
  );
}

export default TagInput;
